import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/buildings_/$buildingId/")({
  beforeLoad: ({ params: { buildingId } }) =>
    redirect({ to: "/buildings/$buildingId/dashboard", params: { buildingId } }),
});
